<template>
  <v-select
    v-model="selected"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    multiple
    label="email"
    class="flex-grow-1 email-to-selector"
    input-id="notification-to"
    placeholder="Ingrese el correo de un usuario"
    :options="usuarios"
    :selectable="() => selected.length < 1"
    :reduce="val => val.id"
    @search="onSearch"
    @input="(val) => $emit('add-id-referencia-lk', val[0])"
  >
    <!-- Options -->
    <template #option="{ nombre, email, emailAlt, cuenta }">
      <div class="d-flex align-items-center text-truncate">
        <b-avatar
          class="mr-1"
          variant="secondary"
          :text="avatarText(cuenta)"
        />
        <div>
          <div class="font-weight-bolder">
            {{ nombre }} ({{ cuenta }})
          </div>
          <div class="font-small-2">
            {{ email }} - {{ emailAlt }}
          </div>
        </div>
      </div>
    </template>

    <!-- Selected option -->
    <template #selected-option="{ nombre, cuenta }">
      <span class="text-white">{{ nombre }} ({{ cuenta }})</span>
    </template>

    <!-- No options -->
    <template #no-options>
      No encontramos resultados
    </template>

    <!-- Loader -->
    <template #spinner="{ loading }">
      <b-spinner
        v-if="loading"
        small
        variant="primary"
      />
    </template>
  </v-select>
</template>

<script>
import {
  VBTooltip,
  BSpinner,
  BAvatar,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import { avatarText } from '@core/utils/filter'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    vSelect,
    BSpinner,
    BAvatar,
  },
  setup() {
    const toast = useToast()
    const showLoader = ref(false)
    const selected = ref([])
    const usuarios = ref([])

    // * Buscador de usuarios
    const onSearch = (search, loading) => {
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS
      const paramsRequest = {
        action: 15,
        x: search,
        token: store.state.cuenta.session.token,
      }

      loading(true)
      getData(paramsRequest, 'wsusuarios')
        .then(response => {
          loading(false)
          if (response.status === 200) {
            usuarios.value = response.data.data || []
            return true
          }
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando usuarios',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
          return false
        })
        .catch(error => {
          loading(false)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando usuarios',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      return true
    }

    // * Asign default data
    const resetComponent = () => { selected.value = [] }

    return {
      showLoader,
      onSearch,
      selected,
      usuarios,
      avatarText,
      resetComponent,
    }
  },
}
</script>
